import io from "./build/index.js";

export const Manager = io.Manager;
export const Socket = io.Socket;
export { io };
export default io;
